'use client';

import clsx from 'clsx';
import type { ReactNode } from 'react';

import { Icon } from '@/components/ui/Icon';

import styles from './InlineInfoAlert.module.scss';

export interface InlineInfoAlertProps {
  children: ReactNode;
  id?: string;
  className?: string;
  'data-testid'?: string;
}

export function InlineInfoAlert({
  children,
  id,
  className,
  'data-testid': testId,
}: Readonly<InlineInfoAlertProps>) {
  return (
    <div id={id} className={clsx(styles.alert, className)} role="note" data-testid={testId}>
      <span className={styles.icon} aria-hidden="true">
        <Icon name="info-filled" size={20} className={styles.iconGlyph} />
      </span>
      <p className={styles.message}>{children}</p>
    </div>
  );
}
